import { writable } from "svelte/store";

export const value = writable(null);
